import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "lp_cookie_notice_ack";

export default function CookieBanner() {
  const [show, setShow] = useState(() => !localStorage.getItem(KEY));
  if (!show) return null;
  const accept = () => { localStorage.setItem(KEY, new Date().toISOString()); setShow(false); };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-50 bg-navy-paper/95 backdrop-blur-md border border-gold/40 p-5 shadow-2xl animate-fade-up" role="dialog" aria-label="Cookie notice" data-testid="cookie-banner">
      <div className="flex gap-3">
        <Cookie className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" />
        <div>
          <div className="text-gold text-xs uppercase tracking-[0.3em]">Cookies</div>
          <p className="text-slate-300 text-sm leading-relaxed mt-2">
            We use cookies to keep you logged in, keep your account secure and improve the site. By continuing to use the site you agree to our use of cookies.
          </p>
          <div className="flex items-center gap-4 mt-4">
            <Button onClick={accept} className="bg-gold text-navy hover:bg-gold-light rounded-none font-bold uppercase tracking-widest text-xs px-5" data-testid="cookie-accept-btn">Got it</Button>
            <Link to="/privacy#cookies" onClick={accept} className="text-gold text-xs uppercase tracking-widest underline hover:text-gold-light" data-testid="cookie-policy-link">Read cookie policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
